import type { CrawlerCategory } from '@prerender/diagnostics-api';

const CRAWLER_CATEGORY_LABELS: Record<CrawlerCategory, string> = {
  search: 'Search engines',
  ai: 'AI crawlers',
  social: 'Social media',
  other: 'Other crawlers',
};

const CRAWLER_CATEGORY_HEADLINE_SUBJECTS: Record<CrawlerCategory, string> = {
  search: 'Search engine crawler',
  ai: 'AI crawler',
  social: 'Social media crawler',
  other: 'Other crawler',
};

export function crawlerCategoryLabel(category: CrawlerCategory): string {
  return CRAWLER_CATEGORY_LABELS[category];
}

export function crawlerCategoryHeadlineSubject(category: CrawlerCategory): string {
  return CRAWLER_CATEGORY_HEADLINE_SUBJECTS[category];
}
